import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedReason } from 'contracts/Reasons';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_REASONS_',
  }
);

export interface ListReasonsState {
  data: ListedReason[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListReasonsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedReason[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListReasonsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListReasonsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListReasonsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListReasonsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListReasonsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listReasons = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListReasonsTypes = Types;
export const ListReasonsActions = Creators;
